import { Link } from "react-router-dom";
import React from "react";
const Bieppsidebar = ({ token, username, isActive, onToggle }) => {
    if (username.bedrijf && username.bedrijf.modules.includes("biepp")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "faciliteitmedewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fa fa-swatchbook"></i>
            </span>
            <span className="menu-text">Biepp</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/biepp" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-search"></i>
                </span>
                <span className="menu-text">Activiteiten zoeken</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/biepp/insert" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-plus"></i>
                </span>
                <span className="menu-text">Activiteiten toevoegen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/biepp/beheer" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-swatchbook"></i>
                </span>
                <span className="menu-text">Activiteiten beheren</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default Bieppsidebar;
